import { AxiosRequestConfig } from 'axios';
import axiosIntercept from '../../app/authentication/axiosIntercept';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
	skipGlobalErrorHandling?: boolean;
}

export const QuestionnaireSpecificResultsResponse = async (
	questionnaireId: string,
	config: CustomAxiosRequestConfig = {}
) => {
	return axiosIntercept.get(`questionnaire/${questionnaireId}`, {
		...config,
		skipGlobalErrorHandling: true,
	} as AxiosRequestConfig);
};

export default QuestionnaireSpecificResultsResponse;
